// extracted by mini-css-extract-plugin
module.exports = {"title":"KeyTermsListBlock_title__bbAsS","container":"KeyTermsListBlock_container__Dz8LS","list":"KeyTermsListBlock_list__Kklh9","headerRow":"KeyTermsListBlock_headerRow__5KMgL"};